import owd from 'owd/owd';

export default class InlineDots extends owd.Component {
	init() {
        this.item = this.$element.find('.lineup-list-item');
        this.selector = this.$element.data('inline-dots');

        if (!this.selector) {
            this.selector = 'li';
        }

        this.split();
        this.bind();
    }

    split() {
        this.item.each(function() {
            let letter = $(this).text().split('');
            $(this).empty();
            letter.forEach((i, obj) => {
                $(this).append($('<span>').text(i));
            })
        })
    }

    fit() {
        this.$element.find(this.selector)
            .removeClass('is-last-in-row')
            .each(function() {
                $(this).addClass('is-last-in-row');

                this.currEnd = $(this).find('.lineup-list-item > span:last-child');
                this.currEndOffset = this.currEnd.offset().left;

                this.nextStart;
                this.nextStartOffset;

                if ($(this).next().length) {
                    this.nextStart = $(this).next().find('.lineup-list-item > span:first-child');
                    this.nextStartOffset = $(this.nextStart).offset().left;

                    if (this.nextStartOffset > this.currEndOffset) {
                        $(this).removeClass('is-last-in-row');
                    }
                }
            });
    }

	bind() {
        this.on('ajaxload load resize-x', this.dom.$window, (e) => {
            this.fit();
        });
    }
}

owd.registerComponent('inline-dots', {
	component: InlineDots
});